import { useParams } from 'react-router-dom';
import TableauPrevelements from "@/pages/paiements/prelevements/tableau-prelevements";
import SmallSpinner from '@/components/shared/spinners/small-spinner';
import { getLastReceipt, useContractReceipts } from '@/hooks/api/use-receipts';
import type { Quittance } from '@/types/api/payment';

const Prelevements = () => {
    const { id: contract_id } = useParams();
    // Relu à chaque montage, comme l'ancien `load`.
    const receiptsQuery = useContractReceipts(contract_id);
    const derniere_quittance = getLastReceipt(receiptsQuery.data) as Quittance | undefined;

    if (receiptsQuery.isError) return <p>Erreur dans le chargement</p>;
    if (receiptsQuery.isPending) return <SmallSpinner />;

    return (
        <div>
            <TableauPrevelements quittance_id={derniere_quittance?.id_belair} contract_id={contract_id}/>
        </div>
    );
};


export default Prelevements;
